import PortraitIcon from "@mui/icons-material/Portrait";
import CreateBuyerProfiles from "./Create";
import ListBuyerProfiles from "./List";
import EditBuyerProfiles from "./Edit";
import ShowBuyerProfiles from "./Show";
//params
export const BUYER_PROFILES = "buyer-profiles";
//permissions

export const resources = {
  isMenu: true,
  icon: <PortraitIcon />,
  name: BUYER_PROFILES,
  title: "Профил на купувача",
  list: <ListBuyerProfiles />,
  create: <CreateBuyerProfiles />,
  edit: <EditBuyerProfiles />,
  show: <ShowBuyerProfiles />,
  permission: "publicProcurementAct",
};

//api url
